import {
  UploadDocumentSpecifiqueUsingPOSTQueryParams,
  UploadDocumentSpecifiqueViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

export const DocumentSpecifiqueFormField = {
  ...UploadDocumentSpecifiqueViolationDtoFormFieldEnum,
} as const;

export type DocumentSpecifiqueFormFieldEnumType =
  typeof DocumentSpecifiqueFormField[keyof typeof DocumentSpecifiqueFormField];

export type DocumentSpecifiqueFormValue =
  Partial<UploadDocumentSpecifiqueUsingPOSTQueryParams> & {
    file?: File;
  };

export type SubmitFunction = {
  submit: (values: DocumentSpecifiqueFormValue) => Promise<void>;
  inProgress: boolean;
};
